<template>
  <Content>
    <div class="md-layout">
      <div class="btn-request">
        <md-button
          class="md-raised md-primary"
          @click="requestClient">Solicitar Acesso
        </md-button>
      </div>
    </div>

    <md-table
      v-model="customerFiltred"
      md-sort="name"
      md-card
      class="mb-5"
      md-fixed-header>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <label class="title-card-requests">Empresas vinculadas</label>
        </div>

        <md-field
          md-clearable
          class="md-toolbar-section-end">
          <md-input
            v-model="search"
            placeholder="Pesquise pelo nome da empresa..."
            @input="searchOnTable" />
        </md-field>
      </md-table-toolbar>

      <md-table-empty-state
        :md-description="`Nenhuma solicitação encontrada`">
        <div
          class="loading-request-accountant"
          align="center">
          <Spinner
            name="line-scale-pulse-out-rapid"
            color="#448aff"
            no-fade-in/>
        </div>
      </md-table-empty-state>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }" >
        <md-table-cell md-label="Nome Fantasia" md-sort-by="client.name" >{{ item.client.name }}</md-table-cell>
        <md-table-cell md-label="Razão Social" md-sort-by="client.corporateName" >{{ item.client.corporateName }}</md-table-cell>
        <md-table-cell
          v-if="item.client.identification.length === 14"
          md-sort-by="client.identification"
          md-label="CNPJ/CPF">{{ item.client.identification | mask('##.###.###/####-##') }}
        </md-table-cell>
        <md-table-cell
          v-else
          md-sort-by="client.identification"
          md-label="CNPJ/CPF">{{ item.client.identification | mask('###.###.###-##') }}
        </md-table-cell>
        <md-table-cell
          v-if="item.accessAllowed === false"
          md-sort-by="sortableAccessAllowed"
          md-label="Situação"><label class="label-false">Aguardando aprovação</label>
        </md-table-cell>
        <md-table-cell
          v-else
          md-sort-by="sortableAccessAllowed"
          md-label="Situação"><label class="label-true">Aprovado</label>
        </md-table-cell>
        <md-table-cell md-label="Data da Solicitação" md-sort-by="created">{{ formatDate(item.created) }}</md-table-cell>
        <md-table-cell
          v-if="item.accessAllowed === true"
          class="button-access"
          md-label="Ações">
          <md-table-row>
            <div
              class="button-pointer"
              @click.capture="accessDashboard(item)">
              <md-icon>dashboard</md-icon>
            </div>
            <md-tooltip md-direction="bottom">Acessar Dashboard</md-tooltip>
          </md-table-row>
          <md-table-row>
            <div
              class="button-pointer"
              @click.capture="acessClient(item)">
              <md-icon>visibility</md-icon>
            </div>
            <md-tooltip md-direction="bottom">Acessar XMLs</md-tooltip>
          </md-table-row>
          <md-table-row>
            <div
              class="button-pointer"
              @click.capture="acessSped(item)">
              <md-icon>file_copy</md-icon>
            </div>
            <md-tooltip md-direction="bottom">Acessar Speds</md-tooltip>
          </md-table-row>
          <md-table-row class="button-pointer" @click="deleteRequest(item.id)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="bottom">Remover</md-tooltip>
          </md-table-row>
        </md-table-cell>
        <md-table-cell
          v-else
          md-label="Ações"
          class="button-access"
        >
          <md-table-row class="ml-3">
            <md-icon>visibility_off</md-icon>
            <md-tooltip md-direction="bottom">Aguardando aprovação do cliente</md-tooltip>
          </md-table-row>
          <md-table-row class="mr-3 button-pointer" @click="deleteRequest(item.id)">
            <md-icon>delete</md-icon>
            <md-tooltip md-direction="bottom">Remover</md-tooltip>
          </md-table-row>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div
      v-if="$store.getters.isLoading"
      class="loading-page-accountant"
      align="center">
      <Spinner
        name="line-scale-pulse-out-rapid"
        color="#448aff"
        no-fade-in/>
    </div>

  </Content>
</template>
<script>
import Spinner from 'vue-spinkit';
import moment from 'moment';
import swal from 'sweetalert';
import { http } from '../../public/api/backend';
import Content from '../public/Content.vue';

const toLower = text => text.toString().toLowerCase()

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.client.name).includes(toLower(term)))
  }

  return items
}

export default {
  name: 'Requests',
  components: {
    Content,
    Spinner,
    moment
  },
  data() {
    return {
      client: [],
      selected: [],
      customerIdentification: '',
      customerFiltred: [],
      search: null,
    };
  },
  created() {
    this.getClient()
    this.filterClient()
  },
  methods: {

    searchOnTable() {
      this.customerFiltred = searchByName(this.selected, this.search)
    },

    getClient() {
      http.post('application.get-client').then(response => {
        this.client = response.data
      })
    },

    deleteRequest(id) {
      this.loadingSearch = true
      swal({
        title: 'Tem certeza que deseja excluir?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false,
          }
        },
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading();
            return swal.close();
          }
          this.postDeleteRequest(id);
        });
    },

    postDeleteRequest(id) {
      http.post('clipp.delete-request', {
        id,
      })
        .then(() => {
          this.$toasted.show('Registro removido com sucesso!', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle',
          });
          swal.stopLoading();
          swal.close();
          this.filterClient();
        })
    },

    requestClient() {
      this.loadingSearch = true
      swal({
        title: 'Informe o CNPJ da empresa que deseja solicitar o acesso as informações.',
        text: 'Lembrando que a empresa, deverá autorizar o acesso pelo MinhasNotas.',
        icon: 'warning',
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Informe o CNPJ',
          }
        },
        buttons: {
          cancel: {
            text: 'Cancelar',
            value: 'cancel',
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            visible: true,
            closeModal: false
          }
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      })
        .then((value) => {
          if (value === 'cancel') {
            swal.stopLoading()
            swal.close()
            return
          }
          this.postRequestClient(value)
        });
    },

    postRequestClient(value) {
      http.post('clipp.request-access-to-client', {
        identification: this.cleanIdentification(value),
      })
        .then(() => {
          this.$toasted.show('Solicitação enviada com sucesso, aguarde a autorização do cliente.', {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'success',
            icon: 'check_circle'
          });
          swal.stopLoading()
          swal.close()
          this.filterClient()
        })
        .catch(error => {
          this.$toasted.show(error.response.data.error_message, {
            theme: 'outline',
            position: 'bottom-right',
            duration: 5000,
            type: 'error',
            icon: 'error_outline'
          });
          swal.stopLoading()
          swal.close()
        });
    },

    filterClient() {
      http.post('clipp.get-accountant-access-request')
        .then(response => {
          this.customerFiltred = response.data.requests
          this.selected = response.data.requests
        })
    },

    accessDashboard(item) {
      this.$store.commit('SET_CLIENT_ID', item.client.id)
      this.$store.commit('SET_CLIENT_NAME', item.client.name)
      this.$store.commit('SET_CLIENT_IDENTIFICATION', item.client.identification)
      this.$store.commit('SET_PAGE', 1)
      this.$toasted.show('Os dados foram atualizados.', {
        theme: 'outline',
        position: 'bottom-left',
        duration: 2000,
        type: 'success',
        icon: 'check_circle'
      });
      this.$router.push({ path: '/accountant/dashboard' })
    },

    acessClient(item) {
      this.$store.commit('SET_CLIENT_ID', item.client.id)
      this.$store.commit('SET_CLIENT_NAME', item.client.name)
      this.$store.commit('SET_CLIENT_IDENTIFICATION', item.client.identification)
      this.$store.commit('SET_PAGE', 1)
      this.$store.dispatch('getDocuments')
      this.$toasted.show('Os dados foram atualizados.', {
        theme: 'outline',
        position: 'bottom-left',
        duration: 2000,
        type: 'success',
        icon: 'check_circle'
      });
        this.$router.push({ path: '/accountant/documents' })
    },

    acessSped(item) {
      this.$store.commit('SET_CLIENT_ID', item.client.id)
      this.$store.commit('SET_CLIENT_NAME', item.client.name)
      this.$store.commit('SET_CLIENT_IDENTIFICATION', item.client.identification)
      this.$store.commit('SET_PAGE', 1)
      this.$store.dispatch('fetchSped')
      this.$toasted.show('Os dados foram atualizados.', {
        theme: 'outline',
        position: 'bottom-left',
        duration: 2000,
        type: 'success',
        icon: 'check_circle'
      });
        this.$router.push({ path: '/accountant/speds' })
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
    },

    cleanIdentification(value) {
      return value.replace(/\^|~|\?|,|\*|\.|-|\/|/g, '');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/accountant/requests/Requests.vue